import React from "react";
import { Card, Text, makeStyles, tokens } from "@fluentui/react-components";
import {
  Document20Regular,
  Clock20Regular,
  Warning20Regular,
  People20Regular,
  CheckmarkCircle20Regular,
} from "@fluentui/react-icons";
import { getStatusItemColor } from "../../../utils/statusItemHelpers";
import { useTypographyStyles } from "../../../styles/typography.styles";

interface StatusStatisticsProps {
  openCount: number;
  processedCount: number;
  reworkRequiredCount: number;
  qualityReviewedCount: number;
  partnerReviewedCount: number;
  onStatusClick: (status: string) => void;
}

const useStyles = makeStyles({
  container: {
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gap: tokens.spacingVerticalS,
  },
  card: {
    cursor: "pointer",
    padding: tokens.spacingVerticalS,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: tokens.spacingVerticalXXS,
    transition: "all 0.2s ease",
    ":hover": {
      transform: "scale(1.05)",
      boxShadow: tokens.shadow16,
    },
    ":active": {
      transform: "scale(0.98)",
    },
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: tokens.fontSizeBase400,
  },
  label: {
    textAlign: "center",
  },
});

export const StatusStatistics: React.FC<StatusStatisticsProps> = ({
  openCount,
  processedCount,
  reworkRequiredCount,
  qualityReviewedCount,
  partnerReviewedCount,
  onStatusClick,
}) => {
  const styles = useStyles();
  const typography = useTypographyStyles();

  const stats = [
    {
      label: "Open",
      count: openCount,
      icon: Document20Regular,
      background: getStatusItemColor("Open"),
      color: "#ffffff",
      filterValue: "Open",
    },
    {
      label: "Processed",
      count: processedCount,
      icon: Clock20Regular,
      background: getStatusItemColor("Processed"),
      color: "#ffffff",
      filterValue: "Processed",
    },
    {
      label: "Rework Required",
      count: reworkRequiredCount,
      icon: Warning20Regular,
      background: getStatusItemColor("Rework Required"),
      color: "#ffffff",
      filterValue: "Rework Required",
    },
    {
      label: "Quality Reviewed",
      count: qualityReviewedCount,
      icon: People20Regular,
      background: getStatusItemColor("Quality Reviewed"),
      color: "#ffffff",
      filterValue: "Quality Reviewed",
    },
    {
      label: "Partner Reviewed",
      count: partnerReviewedCount,
      icon: CheckmarkCircle20Regular,
      background: getStatusItemColor("Partner Reviewed"),
      color: "#ffffff",
      filterValue: "Partner Reviewed",
    },
  ];

  return (
    <div className={styles.container}>
      {stats.map((stat) => {
        const IconComponent = stat.icon;
        return (
          <Card
            key={stat.label}
            className={styles.card}
            style={{
              background: stat.background,
              color: stat.color,
            }}
            onClick={() => onStatusClick(stat.filterValue)}
          >
            {/* <div className={styles.iconContainer}>
              <IconComponent />
            </div> */}
            <Text className={typography.statNumberCompact}>{stat.count}</Text>
            <Text className={`${typography.statLabel} ${styles.label}`}>{stat.label}</Text>
          </Card>
        );
      })}
    </div>
  );
};
